// Generated by ReScript, PLEASE EDIT WITH CARE


function normalizeSrc(src, origin) {
  try {
    return new URL(src, origin).href;
  }
  catch (exn){
    return src;
  }
}

function steamStaticFallbacks(appId) {
  return [
          "https://cdn.cloudflare.steamstatic.com/steam/apps/" + appId + "/library_600x900_2x.jpg",
          "https://cdn.cloudflare.steamstatic.com/steam/apps/" + appId + "/library_600x900.jpg",
          "https://cdn.cloudflare.steamstatic.com/steam/apps/" + appId + "/header.jpg",
          "https://cdn.cloudflare.steamstatic.com/steam/apps/" + appId + "/capsule_616x353.jpg",
          "https://cdn.cloudflare.steamstatic.com/steam/apps/" + appId + "/capsule_231x87.jpg",
          "https://cdn.cloudflare.steamstatic.com/steam/apps/" + appId + "/capsule_sm_120.jpg"
        ];
}

function optStr(v) {
  if (v !== undefined) {
    return v;
  } else {
    return "";
  }
}

function hasSrc(acc, src) {
  return acc.includes(src);
}

function pushUnique(acc, src) {
  if (src === "" || acc.includes(src)) {
    return acc;
  } else {
    return acc.concat([src]);
  }
}

function buildFallbackQueue(appId, poster, capsuleV5, capsule, header, icon, origin) {
  var steam = appId !== undefined ? (
      appId !== "" ? steamStaticFallbacks(appId) : []
    ) : [];
  var candidates = [
    poster !== undefined ? poster : "",
    capsuleV5 !== undefined ? capsuleV5 : "",
    capsule !== undefined ? capsule : "",
    header !== undefined ? header : "",
    icon !== undefined ? icon : ""
  ];
  var acc = {
    contents: []
  };
  candidates.forEach(function (src) {
        acc.contents = pushUnique(acc.contents, normalizeSrc(src, origin));
      });
  steam.forEach(function (src) {
        acc.contents = pushUnique(acc.contents, normalizeSrc(src, origin));
      });
  return acc.contents;
}

function isLibraryPortrait(src) {
  if (src.includes("/library_600x900")) {
    return true;
  } else {
    return src.includes("/library_600x900_2x");
  }
}

export {
  normalizeSrc ,
  steamStaticFallbacks ,
  optStr ,
  hasSrc ,
  pushUnique ,
  buildFallbackQueue ,
  isLibraryPortrait ,
}
/* No side effect */
